/*
 *
 * UrlClickToPayField
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 03-Jun-2026
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import PortalTextInput from '@nexidigital/portaltextinput'
import { messages } from './languageModule'
import './UrlClickToPayField.scss'

const UrlClickToPayField = ({ formik, active }) => {
  const intl = useIntl()

  return (
    <>
      <div className='urlclicktopayfield_container'>
        <PortalTextInput
          ariaLabelIcon={intl.formatMessage(messages.warningAriaLabel)}
          ariaLabelInput={`${intl.formatMessage(messages.baseUrl)}`}
          id='c2pBaseUrl'
          disabled={!active}
          maxLength={255}
          label={`${intl.formatMessage(messages.baseUrl)}*`}
          placeholderBlank
          error={formik?.errors?.subscriptionParams?.ClickToPayBaseUrl && formik?.touched?.subscriptionParams?.ClickToPayBaseUrl}
          errorText={formik?.errors?.subscriptionParams?.ClickToPayBaseUrl}
          onChange={(e) => formik.setFieldValue('subscriptionParams.ClickToPayBaseUrl', e.target.value)}
          onBlur={() => formik.setFieldTouched('subscriptionParams.ClickToPayBaseUrl', true)}
          onFocus={() => formik.setFieldTouched('subscriptionParams.ClickToPayBaseUrl', false)}
        />    
      </div>
    </>
  )
}

UrlClickToPayField.propTypes = {
  active: PropTypes.bool,
  vas: PropTypes.object.isRequired,
  formik: PropTypes.object.isRequired,
}

UrlClickToPayField.defaultProps = {
  active: false,
  vas: {},
}

export default UrlClickToPayField

